import React, { memo, FC } from "react"
import { Booker, BookerAttendeeInput } from "../../generated/graphql"
import ButtonGroup from "antd/lib/button/button-group"
import { Button, Tooltip } from "antd"
import { EditOutlined } from "@ant-design/icons"
import DeleteButton from "../DeleteButton/DeleteButton"
import { useAttendeeEditLock } from "./useAttendeeEditLock"

type ActionButtonProps = {
    onDelete?: () => void
    onEdit?: () => void
    row: BookerAttendeeInput
    booker: Booker
    deletingAttendee?: boolean
    /** Kurslektions-IDs ALLER Zeilen — gleiche Query-Variablen je Zeile → Apollo dedupliziert auf einen Request. */
    allCourseLessonIds?: string[]
}

const ActionButtons: FC<ActionButtonProps> = ({ onDelete, onEdit, row, booker, deletingAttendee, allCourseLessonIds }) => {
    const { firstname } = row
    const { blocked, loading, editTooltip, deleteTooltip } = useAttendeeEditLock(row, allCourseLessonIds)

    const attendeeIsBooker = booker.customerId === row.customer.id

    const editDisabledText = () => {
        if (attendeeIsBooker) {
            return "Der Bucher kann nicht bearbeitet werden. Gehe dazu in deinen Profil"
        }
        return editTooltip
    }

    const deleteDisabledText = () => {
        if (blocked) {
            return deleteTooltip
        } else if (attendeeIsBooker) {
            return "Bei diesem Teilnehmer handelt es sich um den Bucher, dieser kann nicht gelöscht werden."
        }

        return ""
    }

    return (
        <ButtonGroup>
            <Tooltip title={editDisabledText()} placement='top'>
                <Button
                    size='small'
                    data-testid='EditAttendeeButton'
                    type='primary'
                    icon={<EditOutlined />}
                    onClick={onEdit}
                    disabled={blocked || attendeeIsBooker}
                />
            </Tooltip>
            <DeleteButton
                size='small'
                data-testid='DeleteAttendeeButton'
                loading={loading || deletingAttendee}
                filled
                // disableConfirm
                disabled={blocked || attendeeIsBooker}
                confirmText={`${firstname} entgültig löschen?`}
                onConfirm={onDelete}
                disabledText={deleteDisabledText()}
            />
        </ButtonGroup>
    )
}

export default memo(ActionButtons)
